import { render, staticRenderFns } from "./CustomFieldValueAddModal.vue?vue&type=template&id=a5a3fb38&"
import script from "./CustomFieldValueAddModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldValueAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports